import React, { useCallback } from 'react';
import { SyutSelect } from 'components/ui';
import type { SelectOption } from 'components/ui';
import { propertyService } from 'api/services/propertyService';

interface Props {
  value: string;
  onChange: (id: string) => void;
  required?: boolean;
}

/**
 * Shared property selector for dashboards and reports. Uses async loading
 * with `defaultOptions={true}` so the first 500 properties are pre-cached
 * for instant pick on cold open. Stays consistent with BookingListScreen.
 */
const PropertyFilterField: React.FC<Props> = ({ value, onChange, required = true }) => {
  const loadOptions = useCallback(async (input: string): Promise<SelectOption[]> => {
    const res = await propertyService.getAll({
      searchTerm: input || undefined,
      pageSize: input ? 50 : 500,
      includeInactive: false,
    });
    return (res.data ?? []).map((p: any) => ({
      value: p.id,
      label: `${p.propertyCode} - ${p.propertyName}`,
    }));
  }, []);

  return (
    <div className="filter-field">
      <SyutSelect
        label={required ? <>Property <span className="text-danger">*</span></> : 'Property'}
        value={value}
        onChange={(v) => onChange((v as string) || '')}
        isAsync
        loadOptions={loadOptions}
        defaultOptions={true}
        cacheOptions={false}
        isClearable={!required}
        size="sm"
      />
    </div>
  );
};

export default PropertyFilterField;
